import { render } from "./MarqueeBroadcast.vue?vue&type=template&id=5db58883"
import script from "./MarqueeBroadcast.vue?vue&type=script&lang=js"
export * from "./MarqueeBroadcast.vue?vue&type=script&lang=js"

import exportComponent from "C:\\All Projects\\Digital Sinage Main\\Digital Sinage Admin\\media-device-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__